import { css } from '@emotion/react'
import styles, { textEllipsis, typo, zIndex } from '@mathflat/common/style'
import { elevation } from '@mathflat/common/style/cssStyles'

import DropdownItem from './DropdownItem'
import DropdownItem2 from './DropdownItem2'

const {
  colors: { gray, borderColor },
} = styles

const S = {
  basic: {
    wrapper: css`
      position: relative;

      .__dropdown-list {
        display: none;
      }
      .__dropdown-list.open {
        display: block;
      }
    `,
    dropdownButton: css`
      width: 100%;
      height: 100%;
    `,
    dropdownList: css`
      top: 100%;
      z-index: 1;
    `,
    hiddenResult: css`
      position: absolute;
      visibility: hidden;
      z-index: -1;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
    `,
  },
  theme: {
    defaultTheme: {
      wrap: css`
        /* height: 40px; */

        ${DropdownItem}, ${DropdownItem2} {
          width: 100%;
          padding: 0 12px;
          min-height: 48px;
          border-bottom: 1px solid ${borderColor};
          color: ${gray.$900};

          &.active {
            .check-icon {
              display: inline-block;
            }
          }
          &:hover:enabled {
            background-color: ${gray.$100};
          }
          &:disabled {
            color: ${gray.$500};
            cursor: not-allowed;
          }
          &:last-child {
            border-bottom: 0 none;
          }

          &.disabled-like,
          &.disabled-like:hover {
            border-color: ${gray.$400};
            background-color: ${gray.$200};
            color: ${gray.$500};
          }

          &.disabled-like:hover {
            cursor: default;
          }
        }
      `,
      list: css`
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: calc(100% + 4px);
        right: 0;
        max-height: 314px;
        z-index: ${zIndex.DropdownList};

        overflow: scroll;

        border: 1px solid ${gray.$400};
        border-radius: var(--Radius-100);
        background: white;
        scrollbar-width: none;
        -webkit-scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera*/
        }
      `,
      button: css`
        display: flex;
        align-items: center;
        justify-content: space-between;

        height: 100%;
        width: 100%;
        padding-left: 10px;
        padding-right: 8px;

        border: 1px solid ${gray.$400};
        border-radius: var(--Radius-100);
        background-color: white;

        path {
          fill: ${gray.$500};
        }

        &.dropdown-open path {
          fill: ${gray.$600};
        }

        &:disabled {
          background-color: ${gray.$100};
          color: ${gray.$500};
        }
        > span {
          text-align: left;
          ${textEllipsis(1)};
        }
      `,
    },

    rounded: {
      wrap: css`
        height: 56px;

        ${DropdownItem} {
          display: flex;
          position: relative;
          align-items: center;
          justify-content: center;

          width: 100%;
          min-height: 48px;
          color: ${gray.$800};

          &:hover {
            background-color: ${gray.$100};
          }
          &.active {
            background-color: ${gray.$100};
            color: ${gray.$900};

            .check-icon {
              display: block;
              position: absolute;
              right: 12px;
            }
          }
        }
      `,
      button: css`
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;

        > strong {
          font-weight: 700;
          margin-right: 8px;
          ${typo.heading05};
        }
        &:disabled {
          cursor: not-allowed;
          background-color: ${gray.$100};
        }
      `,
      list: css`
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        left: 8px;
        top: 100%;
        z-index: 1;

        width: calc(100% - 16px);
        max-height: 314px;
        margin-top: 8px;
        overflow: scroll;
        border-radius: var(--Radius-200);
        ${elevation.$01}
        background: white;
        scrollbar-width: none;
        -webkit-scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera*/
        }
      `,
    },
  },
}

export default S
